import React, {CSSProperties} from 'react';
import cx from 'classnames';
import {TextColor, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';

type Props = {
    children: React.ReactNode;
    tag?: 'div' | 'p' | 'span' | 'strong' | 'i' | 'em' | 'small' | 'label';
    fontWeight?: 'bold' | 'medium' | 'normal' | 'thin';
    skin?:
        | 'paragraph-1'
        | 'subtitle-1'
        | 'subtitle-2'
        | 'paragraph-2'
        | 'caption-1'
        | 'caption-2'
        | 'label-1'
        | 'label-2';
    fontStyle?: 'italic' | 'normal';
    textColor?: TextColor;
    startPadding?: boolean;
    endPadding?: boolean;
    wrap?: boolean;
    inline?: boolean;
    onClick?: (arg?: any) => void;
    componentClasses?: string;
    style?: CSSProperties;
};

/*
 * Attention!!! Don't use this component for new layouts.
 * Instead, please use the `Text` component directly from the Design System.
 * In the future `Label` component will be removed from the project
 */

export const Label = ({
    children,
    componentClasses,
    wrap = false,
    tag = 'label',
    textColor = 'secondary-400',
    skin = 'paragraph-2',
    ...restProps
}: Props) => {
    return (
        <Text
            componentClasses={cx(styles.label, styles.fontFamily, componentClasses)}
            wrap={wrap}
            tag={tag}
            textColor={textColor}
            skin={skin}
            {...restProps}
        >
            {children}
        </Text>
    );
};
